import React from 'react'
import Spin from '../../component/loading/Spin'
const ButtonPrimary = ({textStyle, style, type, loading, text_button}) => {
    return <button className={`p-2 rounded-md text-light w-full ${style}`} type={type}>{loading == false ? (
        <span className={`${textStyle}`} >{text_button}</span>
    ) : (
        <Spin/>
    )}</button>
}
export default ButtonPrimary